jQuery(function() {
    $('.pie-chart  path').click(function(){
        var pieSectionIndex = $(this).index()+2;
        if($('.pie-chart--active').length && $(window).width() <= 1025){
            $('.default-label div').slideUp('fast')
        }else{
            $('.default-label div').slideDown();
        }
        $('.pie-chart path').removeClass('path-active');
        $('.life-cycle-items').addClass('pie-chart--active')
        $(this).addClass('path-active');
        $('.life-cycle-items li .pie-item__content ').slideUp('fast')
        $('.life-cycle-items li:nth-child('+ pieSectionIndex +') .pie-item__content ').slideDown();
       
        
    })
    $(document).click(function(event) { 
        var $target = $(event.target);
        if(!$target.closest('.pie-chart path').length) {
            $('.pie-chart path').removeClass('path-active');
            $('.life-cycle-items li .pie-item__content ').slideUp('fast')
            $('.life-cycle-items').removeClass('pie-chart--active')
        }        
      });
});


